export default __webpack_public_path__ + "static/media/thumbnails.7b4454c4.svg";